export default "__VITE_ASSET__DayV8zci__"